import { render } from "./EmployeeInvoices.vue?vue&type=template&id=2ae11f74"
import script from "./EmployeeInvoices.vue?vue&type=script&lang=js"
export * from "./EmployeeInvoices.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__